var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back-button"},[_c('b-button',{on:{"click":_vm.goBack}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'chevron-left']}}),_vm._v(" Zurück ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }